var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "rtb-dashboard__rtb-log-detail" },
    [
      _c(
        "Tabs",
        { attrs: { "transition-duration": 0 } },
        [
          _c(
            "Tab",
            { attrs: { title: _vm.$t("TAB_HEAD_BID_DETAILS") } },
            [
              _c("RtbData", {
                attrs: {
                  "bid-record": _vm.bidRecord,
                  "time-zone-id": _vm.timeZoneId
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "Tab",
            { attrs: { title: _vm.$t("TAB_HEAD_BID_TRACE") } },
            [_c("RtbBidTrace", { attrs: { "bid-trace": _vm.bidTrace } })],
            1
          ),
          _vm._v(" "),
          _c(
            "Tab",
            { attrs: { title: _vm.$t("TAB_HEAD_BID_EVENTS") } },
            [_c("RtbEvents", { attrs: { "parsed-events": _vm.mainEvents } })],
            1
          ),
          _vm._v(" "),
          _vm.hasRingTreeEvents
            ? _c(
                "Tab",
                { attrs: { title: _vm.$t("TAB_HEAD_BID_RING_TREE_EVENTS") } },
                [
                  _c("RtbEvents", {
                    attrs: { "parsed-events": _vm.ringTreeEvents }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "Tab",
            { attrs: { title: _vm.$t("TAB_HEAD_BID_TAGS") } },
            [_c("RtbTags", { attrs: { "grouped-tags": _vm.groupedTags } })],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }